import { breakpoints } from "@brightagency/headstart-common";
import { ChevronLeftRounded } from "@mui/icons-material";
import { transparentize } from "polished";
import React from "react";
import styled, { css } from "styled-components";
import { useAssessmentState } from "../../../../services/assessment-state";
import { Screens } from "../../../../services/assessment-state/types";
import { buttonResetStyles } from "../../../../utils";
import { colors } from "../../../../utils/colors";

const Outer = styled.div`
    position: relative;
    display: flex;
    width: 100%;
    max-width: 250px;
    margin: 0 auto 50px;
    padding: 10px 0;

    gap: 8px;

    ${breakpoints.large} {
        max-width: 300px;
        gap: 12px;
    }
`;

const Segment = styled.div<{ isActive: boolean }>`
    position: relative;
    width: 100%;
    height: 4px;
    border-radius: 2px;
    background-color: ${transparentize(0.75, "white")};
    overflow: hidden;
    transform: translateZ(0);

    &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: ${colors.brandLight};
        transform: scaleX(0);
        transform-origin: left;
        transition: 200ms ease all;
    }

    ${({ isActive }) =>
        isActive &&
        css`
            &::after {
                transform: scaleX(1);
            }
        `}
`;

export const BackButton = styled.button`
    ${buttonResetStyles};
    position: absolute;
    top: 50%;
    left: -32px;
    transform: translateY(-50%);
    width: 24px;
    height: 24px;
    color: white;

    ${breakpoints.medium} {
        left: -40px;
    }
`;

export const ProgressBar: React.FC<{
    total: number;
    current: number;
}> = props => {
    const { state, goToScreen, goBack } = useAssessmentState();
    const handlebackclick = () => {
        { (state.currentScreen == 2) ? goToScreen(Screens.Intro)  :  goBack() }
    };

    return (
        <Outer>
            {/* <BackButton onClick={goBack}> */}
            <BackButton onClick={handlebackclick}>
                <ChevronLeftRounded />
            </BackButton>
            {Array(props.total)
                .fill("")
                .map((_, index) => (
                    <>
                        { index == 0 ? 
                            // <Segment className="test" isActive={false} key={index} />
                            null
                            :
                            <Segment isActive={index < props.current} key={index} />
                        }
                    </>
                ))}
        </Outer>
    );
};
